<template>
    <div class="Frame">
        <div class="ShoppingInfoIndex">
            <h2>{{ this.risorse["DettagliSped"] }}</h2>
            <span>{{ this.risorse["IndirizzoDestinazione"] }}</span>
        </div>
        <div class="ShoppingInfo" v-for="(indirizzo, index) in this.$store.getters.getAzienda.Destinazioni" :key="indirizzo.CodiceIndirizzo">           
            <div class="ShoppingInfoDetail SelectedItem">
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormRadio"> 
                            <div class="Label"><span>{{indirizzo.Indirizzo}}</span> <span>{{indirizzo.Cap}} {{indirizzo.Citta}},</span> <span>{{indirizzo.Provincia}}</span></div>
                            <div class="Field"><input type="radio"  name="ShippingAddress" :checked="index == 0 ? true : false" @click="this.setShippingAddress(indirizzo.CodiceIndirizzo)"><span class="radiomark"></span></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="SummaryText">
                    <span>{{indirizzo.Indirizzo}}</span> <span>{{indirizzo.Cap}} {{indirizzo.Citta}},</span> <span>{{indirizzo.Provincia}}</span>
                </div> -->
            </div>                
        </div>
    </div>
</template>

<script>
import {risorseMixin} from "@/mixin.js";

export default {
    name: "ShippingInfo",
    methods:{
        setShippingAddress: function(value){
            this.$store.commit('setShippingAddress', value);
        }
    },
    mixins:[risorseMixin],
    mounted: function(){
        let destinazioni = this.$store.getters.getAzienda.Destinazioni;

        if(destinazioni.length > 0){
            this.$store.commit('setShippingAddress', this.$store.getters.getAzienda.Destinazioni[0].CodiceIndirizzo);
        }

    }
}
</script>